import {DataSeries} from '../../../types/GraphTypes';

export function transformGraphRendererData(dataSeries: DataSeries[]): Record<string, number | string | null>[] {
  if (dataSeries.length === 0) {
    return [];
  }

  // Get all unique x values from all series
  const allXValues = new Set<number>();
  dataSeries.forEach((series) => {
    series.data.forEach((point) => {
      // Include all x values, even if they appear in only one series
      allXValues.add(point.x);
    });
  });

  const sortedXValues = Array.from(allXValues).sort((a, b) => a - b);

  // Create data points for each x value
  // Include all points, even if a series doesn't have a value for that x
  return sortedXValues.map((xValue) => {
    const dataPoint: Record<string, number | string | null> = {x: xValue};

    dataSeries.forEach((series) => {
      // Find all points with this x value (in case of duplicates)
      const points = series.data.filter((p) => p.x === xValue);
      // For line/bar charts, if there are multiple points with same x,
      // use the last one (most recent value)
      // This ensures we don't lose data points
      const point = points.length > 0 ? points[points.length - 1] : null;
      dataPoint[series.key] = point ? point.y : null;
    });

    return dataPoint;
  });
}
